import { memo } from 'react';
import {
  Box,
  Button,
  FormField,
  Modal,
  Select,
  SelectProps,
  SpaceBetween,
} from '@amzn/awsui-components-core';

interface Props {
  readonly options: readonly SelectProps.Option[];
  readonly selectedOption: SelectProps.Option | null;
  readonly isConfirmDisabled: boolean;
  readonly isConfirming: boolean;
  readonly onChange: (option: SelectProps.Option) => void;
  readonly onDismiss: () => void;
  readonly onConfirm: () => void;
}

/** Approve-time modal where a bar raiser assigns a public release priority for external content. */
export const ReleasePriorityModal = memo(function ReleasePriorityModal({
  options,
  selectedOption,
  isConfirmDisabled,
  isConfirming,
  onChange,
  onDismiss,
  onConfirm,
}: Props) {
  return (
    <Modal
      visible
      header="Assign public release priority"
      onDismiss={onDismiss}
      closeAriaLabel="Close modal"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onDismiss}>
              Cancel
            </Button>
            <Button
              variant="primary"
              loading={isConfirming}
              disabled={isConfirmDisabled}
              onClick={onConfirm}
            >
              Publish
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      <FormField
        label="Public release priority"
        description="Sets the priority tech writers see when scheduling this content for public release."
      >
        <Select
          selectedOption={selectedOption}
          options={[...options]}
          placeholder="Select a priority"
          selectedAriaLabel="Selected"
          onChange={({ detail }) => onChange(detail.selectedOption)}
        />
      </FormField>
    </Modal>
  );
});
